import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable';

const LeftSidebarCard = Loadable(lazy(() => import("./LeftSidebarCard")));
const UserProfile = Loadable(lazy(() => import("./user-profile/UserProfile")));

const pageLayoutRoutes = [
    {
        path: '/page-layouts/account-settings',
        element: <LeftSidebarCard />,
    },
    {
        path: '/page-layouts/user-profile',
        element: <UserProfile />,
    },
]

export default pageLayoutRoutes
